/**
 * @file PickingTaskAccessNotice.tsx
 * @description Доступ к заданию: полоса-пояснение до начала работы
 * (phase19.14, экран B шага 0; полосы приведены к `NoticeStrip` в phase19.24
 * этап 1, шаг 1).
 *
 * Четыре взаимоисключающих состояния (задание закрыто, нет права сборки,
 * задание ничьё, задание чужое) — отдельный компонент вместо каскада
 * тернарников в странице: страница остаётся про раскладку.
 */

import { NoticeStrip } from "../../ui/NoticeStrip";
import {
  isActivePickingTask,
  type PickingTaskDetailDto,
} from "../../../lib/api-picking";

interface Props {
  task: PickingTaskDetailDto;
  /** Право SHOP_WMS_PICKING. */
  canExecute: boolean;
  /** Задание взял текущий пользователь. */
  mine: boolean;
}

export function PickingTaskAccessNotice({ task, canExecute, mine }: Props) {
  if (!isActivePickingTask(task.status)) {
    return (
      <NoticeStrip tone="info">Задание закрыто — отмечать позиции нельзя.</NoticeStrip>
    );
  }
  if (!canExecute) {
    return (
      <NoticeStrip tone="info">
        У вас нет права выполнять сборку — задание доступно только на просмотр.
      </NoticeStrip>
    );
  }
  if (!task.assignee) {
    // Кнопка «Взять в работу» переехала в шапку и sticky-панель: по эталону
    // документа главное действие живёт там, а не баннером во всю ширину над
    // контентом (замечание пользователя 2026-09-16).
    return null;
  }
  if (!mine) {
    return (
      <NoticeStrip tone="warning">
        Задание взял {task.assignee.displayName ?? "другой сотрудник"}. Перехватить
        его нельзя — обратитесь к администратору склада.
      </NoticeStrip>
    );
  }
  return null;
}
